import { v4 as uuidv4 } from 'uuid';

import { IErknmAgreement } from 'APIPackage/KnmModule/interfaces/IErknmAgreement';
import { agreementsTypeSelectOptions } from 'KnmPackage/MainModule/constants/agreementsTypeSelectOptions';
import { approvalBooleanSelectOptions } from 'KnmPackage/MainModule/constants/approvalBooleanSelectOptions';
import { convertInitialKnmDateToFormDate } from 'KnmPackage/MainModule/common/convertInitialKnmDateToFormDate';
import { DATE_FORMAT_LONG_FNS, SYSTEM_DATE_FORMAT_FNS } from 'CorePackage/MainModule/constants/dateFormats';
import { AgreementStatusEnum } from 'APIPackage/KnmModule/enums/AgreementStatusEnum';
import { IRootState } from 'CorePackage/MainModule/interfaces/IRootState';
import { IKnmPmFormResultDecision } from 'KnmPmPackage/MainModule/interfaces/IKnmPmFormResultDecision';
import { IDecisionOrganizationForm } from 'DecisionPackage/MainModule/interfaces/IDecisionOrganizationForm';
import { DictionaryUUIDsEnum } from 'CorePackage/DictionariesModule/enums/DictionaryUUIDsEnum';

import { IErknmFormAgreement } from '../interfaces/IErknmFormAgreement';
import { IErknmAgreementResultDecisionSelectOption } from '../interfaces/IErknmAgreementResultDecisionSelectOption';
import { convertKnmDataViolatedRequirementsToFormValues } from './convertKnmDataViolatedRequirementsToFormValues';
import { convertAgreementsApproveToFormValues } from './convertAgreementsApproveToFormValues';
import { convertAgreementsChangeToFormValues } from './convertAgreementsChangeToFormValues';
import { IKnmErknmFormResultDecision } from '../interfaces/IKnmErknmFormResultDecision';
import { getGeneralResultDecisionOptions } from './getGeneralResultDecisionOptions';
import { getSelectOption } from './getSelectOption';
import { convertAgreementsTerminateToFormValues } from './convertAgreementsTerminateToFormValues';
import { convertAgreementsExecutionToFormValues } from './convertAgreementsExecutionToFormValues';
import { convertAgreementsPetitionOrganizationToFormValues } from './convertAgreementsPetitionOrganizationToFormValues';
import { convertAgreementsProsecutorOrganizationToFormValues } from './convertAgreementsProsecutorOrganizationToFormValues';

export const convertAgreementsDataToFormValues = (
  agreements: IErknmAgreement[] | null | undefined,
  state: IRootState,
  resultDecisionsKnm?: IKnmErknmFormResultDecision[],
  resultDecisionsPm?: IKnmPmFormResultDecision[],
  organizationDecision?: IDecisionOrganizationForm,
): IErknmFormAgreement[] | undefined => {
  return agreements?.map(item => {
    const resultDecisions = getGeneralResultDecisionOptions(
      resultDecisionsKnm,
      resultDecisionsPm,
      organizationDecision,
    );

    let prescription: IErknmAgreementResultDecisionSelectOption | undefined;
    // @ts-ignore
    const selectedFormPrescription = resultDecisions?.find(rd => rd.guid === item.prescriptionGuid);

    if (selectedFormPrescription) {
      prescription = {
        id: selectedFormPrescription.guid || '',
        value: selectedFormPrescription.guid || '',
        label: `Решение №${selectedFormPrescription.number}`,
      };
    }

    return {
      status: !item.status ? undefined : (item.status as AgreementStatusEnum),
      isNew: !!item.isNew,
      signed: !!item.signed,
      signedFirst: !!item.signedFirst,
      guid: item.guid || undefined,
      listId: item.guid || uuidv4(),
      prescription,
      violations: item.violations ? convertKnmDataViolatedRequirementsToFormValues(item.violations) : undefined,
      petitionOrganizationType:
        item.petitionOrganizationType !== null
          ? agreementsTypeSelectOptions.find(i => i.value === item.petitionOrganizationType)
          : undefined,
      petitionOrganization: convertAgreementsPetitionOrganizationToFormValues(item.petitionOrganization),
      petitionAttachment: item.petitionAttachment ? [item.petitionAttachment] : undefined,
      approvalOfAgreement:
        item.approvalOfAgreement !== null
          ? approvalBooleanSelectOptions.find(i => i.value === item.approvalOfAgreement)
          : undefined,
      approvalOfAgreementAttachment: item.approvalOfAgreementAttachment
        ? [item.approvalOfAgreementAttachment]
        : undefined,
      eliminateViolationsNumber: item.eliminateViolationsNumber || undefined,
      conclusionDate: convertInitialKnmDateToFormDate(
        item.conclusionDate,
        DATE_FORMAT_LONG_FNS,
        SYSTEM_DATE_FORMAT_FNS,
      ),
      eliminateViolationsAttachment: item.eliminateViolationsAttachment
        ? [item.eliminateViolationsAttachment]
        : undefined,
      termOfExecutionAgreement: convertInitialKnmDateToFormDate(
        item.termOfExecutionAgreement,
        DATE_FORMAT_LONG_FNS,
        SYSTEM_DATE_FORMAT_FNS,
      ),
      dateOnApprove: convertInitialKnmDateToFormDate(item.dateOnApprove, DATE_FORMAT_LONG_FNS, SYSTEM_DATE_FORMAT_FNS),
      applicationForConsiderationAttachment: item.applicationForConsiderationAttachment
        ? [item.applicationForConsiderationAttachment]
        : undefined,
      otherAttachments: item.otherAttachments || undefined,
      violationCorrectionProgramAttachments: item.violationCorrectionProgramAttachments || undefined,
      prosecutorOrganization: convertAgreementsProsecutorOrganizationToFormValues(item.prosecutorOrganization),
      fioSigner: item.fioSigner || undefined,
      titleSigner: item.titleSigner?.dictId
        ? getSelectOption<DictionaryUUIDsEnum.POSITIONS>(
            state,
            item.titleSigner?.dictId,
            item.titleSigner?.dictVersionId,
          )
        : undefined,
      approveInfo: convertAgreementsApproveToFormValues(item.approveInfo),
      terminate: convertAgreementsTerminateToFormValues(item.terminate, state),
      changes: convertAgreementsChangeToFormValues(item.changes, state),
      execution: convertAgreementsExecutionToFormValues(item.execution, state),
    };
  });
};
